export default {
    Carousel: {
        id: "Carousel",
        name: "Carousel",
        params: {
            autoplay: { type: "bool" },
            interval: { type: "number" },
        },
    },
    Gallery: {
        id: "Gallery",
        name: "Gallery",
        params: {},
    },
    SectionPopup: {
        id: "SectionPopup",
        name: "SectionPopup",
        params: {},
    },
    NavOverlay: {
        id: "NavOverlay",
        name: "NavOverlay",
        params: {},
    },
    ListFilter: {
        id: "ListFilter",
        name: "ListFilter",
        params: {
            global: "bool",
        },
        roles: ["filter-nav", "filter-list"],
    },
    Popover: {
        id: "Popover",
        name: "Popover",
        params: {},
        roles: ["trigger", "content"],
    },
    Datepicker: {
        id: "Datepicker",
        name: "Datepicker",
        params: {},
    },
    DatepickerInput: {
        id: "DatepickerInput",
        name: "DatepickerInput",
        params: {
            initial: "string",
        },
    },
    Guestpicker: {
        id: "Guestpicker",
        name: "Guestpicker",
        params: {},
    },
    BookingForm: {
        id: "BookingForm",
        name: "BookingForm",
        params: {},
    },
};
